<template lang="html">
    <div class="image-input">
        <div class="set-after" style="margin-bottom: 25px;">
            <label :for="'item-' + this.item.id" class="col-twelve no-padding-left">Image</label>
            <input type="file" accept="image/png,image/jpeg" :name="'items[' + this.item.id + '][image]'" v-on:change="uploadImage" :id="'item-' + this.item.id">
            <input type="hidden" :name="'items[' + this.item.id + '][image_crop]'" v-model="imageCropId">
            <div class="image-cell" :style="cropImage"></div>
            <button type="button" @click="browseImage">Upload Image</button>
            <button class="delete-image" type="button" @click="deleteInput">Delete Collection Item</button>
            <strong :id="'message-' + this.item.id" :class="{ loading: errorClassLoading, 'text-danger': errorClassDanger }" v-if="errorText">{{ errorText }}</strong>
        </div>
        <div class="set-after">
            <label :for="'title-' + this.item.id">Title</label>
            <input type="text" :id="'title-' + this.item.id" class="long-input" :name="'items[' + this.item.id + '][title]'" required v-model="itemTitle">
        </div>
        <div class="set-after">
            <label :for="'description-' + this.item.id">Description (not required)</label>
            <textarea :name="'items[' + this.item.id + '][description]'" :id="'description-' + this.item.id" cols="30" rows="4" class="long-input">{{ itemDescription }}</textarea>
        </div>
    </div>
</template>

<script>
export default {
  props: ['item'],
  data() {
    return {
      cropImage: '',
      imageCropId: null,
      itemDescription: '',
      itemTitle: '',
      errorText: '',
      errorClassLoading: false,
      errorClassDanger: false
    };
  },
  methods: {
    browseImage() {
      $('#item-' + this.item.id).click();
    },
    uploadImage() {
      this.errorText = 'Uploading';
      this.errorClassLoading = true;
      this.errorClassDanger = false;
      let formData = new FormData();
      let image = document.getElementById('item-' + this.item.id).files[0];
      if (!image.type.match('image.*')) {
        return false;
      }
      formData.append('image', image);
      axios.post('/ajax/image/upload', formData,
        {
          headers: { 'content-type': 'multipart/form-data' }
        })
        .then((response) => {
          this.errorText = '';
          this.errorClassLoading = false;
          this.imageCropId = response.data.id;
          this.cropImage = "background-image: url('/" + response.data.image + "')";
        }).catch(() => {
          this.errorText = 'Please upload correct image (.JPG, .PNG, 700x700px minimum)';
          this.errorClassLoading = false;
          this.errorClassDanger = true;
        });
    },
    deleteInput() {
      this.$emit('itemDeleted', {
        id: this.item.id
      });
    }
  },
  mounted() {
    // set default value if image was already uploaded
    if (this.item.image !== undefined) {
      this.imageCropId = this.item.id;
      this.cropImage = "background-image: url('/" + this.item.image + "')";
      this.itemTitle = this.item.title;
      this.itemDescription = this.item.description;
    }
  }
};
</script>